import { z } from 'zod'

export enum EngagedFollowersPeriod {
  LAST_7_DAYS = 7,
  LAST_14_DAYS = 14,
  LAST_30_DAYS = 30,
}

const mostEngagedFollower = z.object({
  id: z.number(),
  name: z.string(),
  avatar: z.string().nullable(),
  ig_username: z.string(),
  score: z.number(),
  scoring_components: z.object({
    comments: z.number(),
    story_mentions: z.number(),
    reactions: z.number(),
    dms: z.number(),
    link_clicks: z.number(),
    shares_to_stories: z.number(),
  }),
})

export const mostEngagedFollowersSchema = z.object({
  data: z.array(mostEngagedFollower),
})

export type MostEngagedFollowerSchemaType = z.infer<typeof mostEngagedFollower>
